import { Component } from '@angular/core';

import { AbstractComponent } from '../abstract-component';

@Component({
    selector: 'app-inicio',
    imports: [],
    templateUrl: './inicio.component.html',
    styleUrl: './inicio.component.css'
})
export class InicioComponent extends AbstractComponent {

}
